import { HttpErrorResponse } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { tntFirmware } from "../../interfaces/tnt-firmware.interface";
import { TntFirmwareService } from "../../services/tnt-firmware.service";

@Component({
    selector: 'app-add-edit-tnt-firmware',
    templateUrl: './add-edit-tnt-firmware.component.html',
    styleUrls: ['./add-edit-tnt-firmware.component.scss'],
    standalone: false
})
export class AddEditTntFirmwareComponent implements OnInit {

	processing = false;
	form: any;
	zip_file: any;
	errors: any;

	constructor(
		private fb: UntypedFormBuilder, @Inject(MAT_DIALOG_DATA) public data: any,
		private tntFirmwareService: TntFirmwareService,
		private dialogRef: MatDialogRef<AddEditTntFirmwareComponent>,
	) {
		this.form = this.fb.group(this.data.record ? this.editForm() : this.addForm());

		this.processing = false;
	}

	ngOnInit(): void {
	}

	addForm() {
		return {
			major_version: [''],
			hardware_version: ['', Validators.required],
			firmware_version: ['', Validators.required],
			description: ['']
		};
	}
	editForm() {
		return {
			major_version: [this.data.record.major_version ?? ''],
			hardware_version: [this.data.record.hardware_version, Validators.required],
			firmware_version: [this.data.record.firmware_version, Validators.required],
			description: [this.data.record.description]
		};
	}

	fileChange(fileInputEvent: any) {
		this.zip_file = fileInputEvent.target.files[0];
	}

	submitForm(event: any) {
		event.preventDefault();
		if (!this.form.valid) return;

		this.processing = true;
		const record = this.form.value as tntFirmware;
		record.zip_file = this.zip_file;

		if (this.data.record) record.id = this.data.record.id;
		this.tntFirmwareService.storeOrUpdate(record)
			.subscribe((res: any) => {
				this.dialogRef.close(res.status);
			},
			(errorResponse: HttpErrorResponse) => {
				this.errors = errorResponse.error['errors'];
				if(this.errors.errors){
					for(let key in this.errors.errors){
						if(this.form.controls[key]){
							this.form.controls[key].setErrors({'incorrect': true});
						}
					}
				}
				this.processing = false;
			},);
	}
}
